import React from 'react'
import MemberUserList from './memberUsers/memberUserList/MemberUserList';

const AllAdminAndUserList = () => {

    return (
        <div className='w-full'>
            <div>
                <MemberUserList />
            </div>
        </div>
    )
}

export default AllAdminAndUserList